<template>
  <session class="mobile-page-login">
    <Header />
    <!-- <div class="login-comp-wrap"> -->
      <!-- <div class="login-comp-l"> -->
      <div class="login-form-block" v-if="step == 1">
        <div class="blocktitle">
          <span class="main">{{LOCAL('login_loginType')}}</span>
          <span class="sub" v-html="Utils.presetHtmlText(LOCAL('login_loginType_desc'))" />
        </div>
        <div class="blockcate">
          <div class="item" :class="{ active: curEntrance?.id == item?.id }" v-for="(item, index) in entrancesList" :key="index" @click="selectEntrance(item)">
            <span class="title">{{item?.title}}</span>
            <span class="desc">{{item?.desc}}</span>
            <div class="sign-wrap"><Icon :name="item.icon" size="98" /></div>
          </div>
        </div>
      </div>
      <div class="login-form-block" v-if="step == 2">
        <div class="blocktitle">
          <div class="backwrap" @click="backHandle"><Icon name="back" /><span>{{LOCAL('back')}}</span></div>
          <span class="main">{{curEntrance?.title}}</span>
        </div>
        <div class="blockform-wrap">
          <div class="item">
            <Icon name="account" size="18" />
            <div class="input-wrap"><input v-model="accountValue" :placeholder="`${LOCAL('account')}/${LOCAL('email')}`" /></div>
            <div class="errortip" v-if="showAccountError">{{ LOCAL('login_error_account') }}</div>
          </div>
          <div class="item">
            <Icon name="password" size="18" />
            <div class="input-wrap">
              <input v-model="passwordValue" autocomplete="new-password" :type="showPassword ? 'text' : 'password'" :placeholder="LOCAL('password')" type="password" @input="e => startInputPassword(e.target.value)"/>
              <Icon v-if="startInput" size="18" :name="showPassword ? 'pass_0' : 'pass_1'" style="cursor: pointer;" @click="showPassword = !showPassword" />
            </div>
            <div class="errortip" v-if="showPasswordError">{{ LOCAL('login_error_password') }}</div>
          </div>
          <div class="desclink" style="margin-top: -12px;">
            <span v-html="LOCAL('login_forget_password_tip')" /><span class="forget-password" :class="{ fmin: getLocalLangCode() === 'jp' }" @click="toTagetPage2('/resetpassword')" v-html="LOCAL('login_forget_password_find')" />
          </div>
          <div class="submitbtn" @click="submitHandle"><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{LOCAL('login')}}</span></div>
          <div class="desclink" style="margin-top: 24px; justify-content: center;">
            <span v-html="LOCAL('login_noaccount_tip')" /><span class="register-now" @click="toTagetPage('/register',curEntrance?.id)" v-html="LOCAL('login_regsiter_now')" />
          </div>
        </div>
      </div>
  </session>
</template>

<script setup>
  import { ref, onMounted, watch } from 'vue';
  import * as Utils from '@/assets/utils';
  import Header from '@/mobile/components/header/index.vue';
  import Icon from '@/components/icon/index.vue';
  import EventBus from '@/assets/eventbus';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';
  import router from '@/router';
  import { useRoute } from 'vue-router'
const route = useRoute();
  // 流出步骤
  const step = ref(1);  // 1 - 第一步；2 - 第二步

  const show = ref(false);

  /**
   * 第一步
   */
  // 入口列表
  const entrancesList = ref([]);
  const curEntrance = ref(null);
  const init = () => {
    entrancesList.value = [
      { title: LOCAL('login_loginType_1_title'), desc: LOCAL('login_loginType_1_desc'), icon: 'person-blue', id: 'person' },
      { title: LOCAL('login_loginType_2_title'), desc: LOCAL('login_loginType_2_desc'), icon: 'enterprise-blue', id: 'enterprise' },
      { title: LOCAL('login_loginType_3_title'), desc: LOCAL('login_loginType_3_desc'), icon: 'agent-blue', id: 'agent' },
    ]
  }
  onMounted(() => {
    init()
    if(route.query.plan === 'person'){
        curEntrance.value = entrancesList.value[0];
        step.value = 2;
      } else if(route.query.plan === 'unit'){
        curEntrance.value = entrancesList.value[1];
        step.value = 2;
      } else {
        step.value = 1;
      }
  });

  // 选择入口
  const selectEntrance = item => {
    curEntrance.value = item;
    step.value = 2;
  }

  /**
   * 第二步
   */
  const showPassword = ref(false);

  const accountValue = ref('');
  const passwordValue = ref('');
  const showAccountError = ref(false);
  const showPasswordError = ref(false);
  const startInput = ref(false)

  const startInputPassword = (e) => {
  if(e.length > 0){
  startInput.value = true

  } else {
  startInput.value = false}
}


  // 返回
  const backHandle = () => {
    step.value = 1;
    accountValue.value = '';
    passwordValue.value = '';
    showAccountError.value = false;
    showPasswordError.value = false;
    router.replace({
      path: '/login'
    })
  }

  // 提交
  const submitHandle = () => {
    console.log('accountValue.value', accountValue.value, 'passwordValue.value', passwordValue.value);
    showAccountError.value = false;
    showPasswordError.value = false;

    if(!accountValue.value) {
      showAccountError.value = true;
      return;
    }
    if(!passwordValue.value) {
      showPasswordError.value = true;
      return;
    }
  }
  const rt = useRoute();

  const toTagetPage = (path, para) => {
    if(rt.path === '/register') {
      router.replace(
      { 
        path: '/register', 
        query: {
          plan: para
        }  
      });
    } else {
      router.push(
      { 
        path: path || '/', 
        query: { 
          plan: para 
        }  
      });
    }
    
  }

  const toTagetPage2 = (path) => {
    Utils.resetPasswordon(false)
    if(rt.path === '/resetpassword') {
      router.replace(
      { 
        path: '/resetpassword', 
      });
    } else {
      router.push(
      { 
        path: path || '/'
      });
    }
    
  }

</script>

<style scoped lang="less">
  @import "index.less";
</style>
